export const REPORTS_READ = "read:reports";
export const ERROR_SCOPES_FETCHING_FAILED = "Scopes fetching failed";
